import Vue from 'vue';
import i18n from '@/language/i18n';

import WorkGlobalIconButton from "@/components/global_components/buttons/WorkGlobalIconButton";

function createGlobalIconButton(name, icon, tooltip) {
  Vue.component(name, {
    extends: WorkGlobalIconButton,
    data() {
      return {
        icon,
        tooltip
      }
    }
  });
}

createGlobalIconButton('WAccessConfigButton', '$wAccessConfig', i18n.t('Components.words.accessConfiguration'));
createGlobalIconButton('WAddButton', '$wAdd', i18n.t('Common.add'));
createGlobalIconButton('WApplicationRejectButton', '$wApplicationReject');
createGlobalIconButton('WApplicationReopenButton', '$wApplicationReopen');
createGlobalIconButton('WArchivedButton', '$wArchived');
createGlobalIconButton('WArrowDown', '$wArrowDown');
createGlobalIconButton('WAttentionButton', '$wAttention');
createGlobalIconButton('WBackButton', '$wBack', i18n.t('Utility.back'));
createGlobalIconButton('WBulkExecuteSelectionButton', '$wBulkExecuteSelection');
createGlobalIconButton('WBusinessTripButton', '$wBusinessTrip');
createGlobalIconButton('WCalculationButton', '$wCalculation');
createGlobalIconButton('WCalendarButton', '$wCalendar');
createGlobalIconButton('WCallButton', '$wCall', i18n.t('Components.sentences.callNumber'));
createGlobalIconButton('WCameraButton', '$wCamera', i18n.t('Components.sentences.openCamera'));
createGlobalIconButton('WCarButton', '$wCar');
createGlobalIconButton('WCheckButton', '$wCheck');
createGlobalIconButton('WCheckboxSelectAllButton', '$wCheckboxSelectAll');
createGlobalIconButton('WCheckboxIndeterminateButton', '$wCheckboxIndeterminate');
createGlobalIconButton('WCheckboxMinusButton', '$wCheckboxMinus');
createGlobalIconButton('WCircleButton', '$wCircle');
createGlobalIconButton('WCloseButton', '$wClose', i18n.t('Common.close'));
createGlobalIconButton('WCollapseButton', '$wCollapse', i18n.t('Common.foldup'));
createGlobalIconButton('WColorNoSelectionButton', '$wColorNoSelection');
createGlobalIconButton('WColorSelectionButton', '$wColorSelection');
createGlobalIconButton('WCompanyButton', '$wCompany');
createGlobalIconButton('WCompanyAddButton', '$wCompanyAdd');
createGlobalIconButton('WConfirmDeviationButton', '$wConfirmDeviation');
createGlobalIconButton('WContainerButton', '$wContainer');
createGlobalIconButton('WCopyProjectButton', '$wCopyProject');
createGlobalIconButton('WCreateBillButton', '$wCreateBill');
createGlobalIconButton('WCustomerButton', '$wCustomer');
createGlobalIconButton('WCustomer', '$wCustomer');
createGlobalIconButton('WDashboardButton', '$wDashboard');
createGlobalIconButton('WDeleteButton', '$wDelete', i18n.t('Common.delete'));
createGlobalIconButton('WDeputyButton', '$wDeputy');
createGlobalIconButton('WDocumentButton', '$wDocument');
createGlobalIconButton('WDocumentAddButton', '$wDocumentAdd');
createGlobalIconButton('WDunningButton', '$wDunning');
createGlobalIconButton('WPlusButton', '$wPlus');
createGlobalIconButton('WDownButton', '$wDown');
createGlobalIconButton('WDownloadButton', '$wDownload', i18n.t('Common.download'));
createGlobalIconButton('WDownloadCsvButton', '$wDownloadCsv', i18n.t('Common.download'));
createGlobalIconButton('WDownloadExcelButton', '$wDownloadExcel', i18n.t('Common.download'));
createGlobalIconButton('WDownloadZipButton', '$wDownloadZip', i18n.t('Common.download'));
createGlobalIconButton('WEditButton', '$wEdit', i18n.t('Common.edit'));
createGlobalIconButton('WEditModeOffButton', '$wEditModeOff', i18n.t('Components.sentences.activateEditMode'));
createGlobalIconButton('WEditModeOnButton', '$wEditModeOn', i18n.t('Components.sentences.activateReadMode'));
createGlobalIconButton('WEditViewButton', '$wEditView');
createGlobalIconButton('WElectricMagnifierButton', '$wElectricMagnifier');
createGlobalIconButton('WEmailButton', '$wEmail', i18n.t('Components.sentences.sendMail'));
createGlobalIconButton('WEqualsButton', '$wEquals');
createGlobalIconButton('WExportButton', '$wExport');
createGlobalIconButton('WExportMessageButton', '$wExportMessage');
createGlobalIconButton('WFavoriteButton', '$wFavorite');
createGlobalIconButton('WFavoriteFilledButton', '$wFavoriteFilled');
createGlobalIconButton('WFilterButton', '$wFilter');
createGlobalIconButton('WFilterAddButton', '$wFilterAdd');
createGlobalIconButton('WFilterSelectButton', '$wFilterSelect');
createGlobalIconButton('WGlobalSearchButton', '$wGlobalSearch');
createGlobalIconButton('WGreaterThanButton', '$wGreaterThan');
createGlobalIconButton('WHamburgerMenuButton', '$wHamburgerMenu');
createGlobalIconButton('WHelpButton', '$wHelp', i18n.t('Common.help'));
createGlobalIconButton('WHistoryButton', '$wHistory');
createGlobalIconButton('WImportButton', '$wImport');
createGlobalIconButton('WInfoButton', '$wInfo');
createGlobalIconButton('WKeyButton', '$wKey');
createGlobalIconButton('WLinkButton', '$wLink');
createGlobalIconButton('WLogoutButton', '$wLogout');
createGlobalIconButton('WMessageAddButton', '$wMessageAdd');
createGlobalIconButton('WNextButton', '$wNext');
createGlobalIconButton('WNotificationButton', '$wNotification');
createGlobalIconButton('WNotInSyncButton', '$wNotInSync');
createGlobalIconButton('WMinusButton', '$wMinus');
createGlobalIconButton('WMobilePhoneButton', '$wMobilePhone');
createGlobalIconButton('WModuleOverviewButton', '$wModuleOverview');
createGlobalIconButton('WMoveableButton', '$wMoveable');
createGlobalIconButton('WOptionsButton', '$wOptions');
createGlobalIconButton('WOutsideOfficeButton', '$wOutsideOffice');
createGlobalIconButton('WPaymentReminderButton', '$wPaymentReminder');
createGlobalIconButton('WPriceUploadButton', '$wPriceUpload');
createGlobalIconButton('WPrinterButton', '$wPrinter', i18n.t('Components.sentences.printLabel'));
createGlobalIconButton('WQrCode', '$wPrinter', i18n.t('MobileDeviceBridge.sentences.scanEntry'));
createGlobalIconButton('WRefreshButton', '$wRefresh', i18n.t('Common.refresh'));
createGlobalIconButton('WRevertArchivedButton', '$wRevertArchived');
createGlobalIconButton('WRotateButton', '$wRotate');
createGlobalIconButton('WSaveButton', '$wSave', i18n.t('Common.save'));
createGlobalIconButton('WScanButton', '$wScan', i18n.t('Components.sentences.scanDocument'));
createGlobalIconButton('WSearchButton', '$wSearch', i18n.t('Common.search'));
createGlobalIconButton('WSettingsButton', '$wSettings');
createGlobalIconButton('WSerialNumberButton', '$wSerialNumber', i18n.t('Devices.sentences.inputManufaturerSerialNumber'));
createGlobalIconButton('WServiceButton', '$wService');
createGlobalIconButton('WSmallerThanButton', '$wSmallerThan');
createGlobalIconButton('WStockButton', '$wStock', i18n.t('Components.sentences.captureStockMovement'));
createGlobalIconButton('WSyncButton', '$wSync');
createGlobalIconButton('WTableLayoutButton', '$wTableLayout');
createGlobalIconButton('WTag', '$wTag');
createGlobalIconButton('WTimeButton', '$wTime');
createGlobalIconButton('WUnfoldButton', '$wUnfold', i18n.t('Common.expand'));
createGlobalIconButton('WUnlinkButton', '$wUnlink', i18n.t('Components.sentences.removeLink'));
createGlobalIconButton('WUnreadableSerialNumberButton', '$wUnreadableSerialNumber', i18n.t('Devices.sentences.manufacturerSerialNumberIsUnreadable'));
createGlobalIconButton('WUpButton', '$wUp');
createGlobalIconButton('WUploadButton', '$wUpload', i18n.t('Components.sentences.uploadFiles'));
createGlobalIconButton('WUserButton', '$wUser');
createGlobalIconButton('WViewButton', '$wView', i18n.t('Components.sentences.openImagePreview'));
createGlobalIconButton('WWarningIconButton', '$wWarning');
createGlobalIconButton('WWebButton', '$wWeb', i18n.t('Contacts.sentences.openAddress'));
createGlobalIconButton('WWidgetButton', '$wWidget');
createGlobalIconButton('WWordButton', '$wWord');
